//多语师资
export default [
	{
		path: '/teachers',
		name: 'teachers',
		component: () => import('@/views/teachers'),
		meta: {
			metaInfo: {
			  title: "职业技能提升 | 幼师能力提 | 幼师资格证 | 幼师考试 | 幼师培训",
			  keywords: "幼师资格证培训班，幼师资格证培训学校，幼师资格证报名，幼师资格证考试，幼师资格证报考条件，幼师资格证报考，技能提升",
			  description: "新语境教育官网是集幼师培训,幼师考证,幼师就业,儿童幼儿绘本,新语境教育模式,职业技能提升,新语境幼儿园,一站式学前教育科技综合服务平台",
			},
		}
	},
	{
		path: '/examination',
		name: 'examination',
		component: () => import('@/views/teachers/teaching/examination'),
	},
	{
		path: '/pay',
		name: 'pay',
		component: () => import('@/views/teachers/teaching/pay')
	},
	{
		path: '/classes',
		name: 'classes',
		component: () => import('@/views/teachers/teaching/classes')
	},
	{
		path: '/see',
		name: 'see',
		meta: {
			isShowFoot: 1
		},
		component: () => import('@/views/teachers/teaching/see')
	},
	{
		path: '/seedetile',
		name: 'seedetile',
		meta: {
			isShowFoot: 1
		},
		component: () => import('@/views/teachers/teaching/seedetile')
	},
	{
		path: '/openClass',
		name: 'openClass',
		component: () => import('@/views/teachers/teaching/openClass')
	},
	{
		path: '/openClassDetail',
		name: 'openClassDetail',
		component: () => import('@/views/teachers/teaching/openClassDetail')
	},
	{
		path: '/teachMethod',
		name: 'teachMethod',
		component: () => import('@/views/teachers/teaching/teachMethod')
	},
	{
		path: '/addclass',
		name: 'addclass',
		component: () => import('@/views/teachers/teaching/addclass'),
		meta: {
			metaInfo: {
			  title: "新语境幼师考试 | 幼师资格证报名入口 | 幼师资格证考试 | 幼师考试条件",
			  keywords: "幼师资格证，幼师资格证考试，幼师资格证报名，幼师资格证报考条件，幼师资格证报考，幼师资格证考试时间，幼师报名考试多少钱，幼师考试内容",
			  description: "新语境教育官网是集幼师培训,幼师考证,幼师就业,儿童幼儿绘本,新语境教育模式,职业技能提升,新语境幼儿园,一站式学前教育科技综合服务平台",
			},
		}
	},
	{
		path: '/post',
		name: 'post',
		component: () => import('@/views/teachers/teaching/post')
	},
	{
		path: '/screen',
		name: 'screen',
		component: () => import('@/views/teachers/teaching/screen')
	},{
		path: '/infoDetails',
		name: 'infoDetails',
		component: () => import('@/views/teachers/teaching/infoDetails')
	},
	{
		path: '/comfirmForm',
		name: 'comfirmForm',
		meta: {
			isShowFoot: 1
		},
		component: () => import('@/views/teachers/teaching/comfirmForm')
	},
	{
		path: '/examinationForm',
		name: 'examinationForm',
		meta: {
			isShowFoot: 1
		},
		component: () => import('@/views/teachers/teaching/examinationForm')
	},
	{
		path: '/questions',
		name: 'questions',
		meta: {
			isShowNav: 1
		},
		component: () => import('@/views/teachers/subject/questions')
	},
	{
		path: '/success',
		name: 'success',
		meta: {
			isShowNav: 1
		},
		component: () => import('@/views/teachers/subject/success')
	},
]


// WEBPACK FOOTER //
// ./src/router/modules/teachers.js